module.exports = __webpack_public_path__ + "img/close-line.ce2e986b.svg";